import React from "react";
import { Button, dialog, InfiniteScroll, Progress } from "nq-component";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import withRouter from "../../../../../withRouter";
import Search from "../../../../../components/Search";
import BaseListPage from "../../../../../base/BaseListPage";
import InputFactory from "../../../../../components/InputFactory";
import { toDisplayCase } from "nq-component";
import NavBar from "../../../../../components/navbar";
import Table from "../../../../../components/Table";
import CollapseView from "./components/CollapseView";
import DialogModal from "../../../../../components/Dialog";
import TransferHistoryPresenter from "./TransferHistoryPresenter";
import RightSidebar from "../../../../../components/RightSidebar";

class TransferHistoryPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new TransferHistoryPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      objects: [],
      selected: [],
      loading: true,
      total: 0,
      count: 0,
      range: "",
      showMobileFilters: false,
    };
  }

  getCollectionName() {
    return "stock_transfers";
  }

  closeDialog() {
    dialog.close();
  }

  onClickImport() {
    this.presenter.onClickImport();
  }

  onClickExport() {
    this.presenter.onClickExport();
  }

  onChangeDate(where) {
    this.presenter.onChangeDate(where);
    this.setState({ range: where });
  }

  onChangeFilter(type, value, field) {
    const where = {};
    switch (type) {
      case "Pointer":
        if (Object.keys(value).length > 0) {
          where[field] = { id: value.id };
        }
        break;
      case "Boolean":
        where[field] = value;
        break;
      default:
        where[field] = { $regex: value, $options: "i" };
    }
    this.searchSubmit(where);
  }

  onClickAdd() {
    this.presenter.onClickAdd();
  }
  onClickView(index) {
    this.presenter.onClickView(index);
  }
  onClickDelete(index) {
    dialog.fire({
      html: (
        <DialogModal
          icon="bi bi-exclamation-octagon-fill"
          iconColor="red"
          title="Confirm Deletion"
          message="This will remove the selected data from the system. Are you sure want to continue?"
          isCancelButton={true}
          onSubmit={() => this.presenter.onClickDelete(index)}
          onClose={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  onExportCsv(index) {}

  onCollapse(index) {
    const stock = this.state.objects[index];
    return (
      <CollapseView
        stock={stock}
        onExportCsv={() => this.onExportCsv(index)}
        onView={() => this.onClickView(index)}
        onDelete={() => this.onClickDelete(index)}
      />
    );
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, selected, count, loading } = this.state;
    if (!schema) return <Progress />;
    return (
      <>
        <NavBar />
        <RightSidebar
          isVisible={this.state.showMobileFilters}
          onClose={() => this.setState({ showMobileFilters: false })}
          onDateChange={this.onChangeDate.bind(this)}
          range={this.state.range}
        />
        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            hasMore={!loading && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div className="d-flex justify-content-between align-items-center">
                <h1
                  className="fw-bold text-capitalize"
                  style={{ color: "#82c14a" }}
                >
                  {schema.label || toDisplayCase(this.getCollectionName())}
                </h1>
                <div className="text-nowrap">
                  <span className="ms-2">
                    {selected.length > 0 ? "Selected: " : "Total: "}
                  </span>
                  <span className="fs-sm text-nowrap">
                    {selected.length > 0 ? selected.length : objects.length}
                  </span>
                  <span className="ms-1">of </span>
                  <span className="fs-sm text-nowrap">{count}</span>
                </div>
              </div>
              <div className="d-flex mt-3">
                {Object.keys(schema.filters || {}).map((field) => {
                  let { type, ...options } = schema.filters[field];
                  return (
                    <InputFactory
                      key={field}
                      className="ms-1"
                      type={type}
                      field={field}
                      where={{}}
                      onChange={this.onChangeFilter.bind(this, type)}
                      {...options}
                    />
                  );
                })}
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <Search
                  schemas={this.getSchemas()}
                  className="mt-3"
                  onSubmit={this.searchSubmit.bind(this)}
                  fields={schema.fields}
                />
                <div className="text-nowrap mt-3">
                  <i
                    className="bi bi-filter fs-1"
                    onClick={() => this.setState({ showMobileFilters: true })}
                    style={{ color: "#83c14a" }}
                  ></i>
                </div>
              </div>
              <Table
                fields={schema.fields}
                objects={objects}
                selectable
                collapsable
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  [
                    "acl",
                    "password",
                    "storeId",
                    "transferNumber",
                    "linkedRequestId",
                    "transferDate",
                    "transferredBy",
                    "remarks",
                  ]
                )}
                selected={selected}
                onSelect={this.onSelect.bind(this)}
                onSelectAll={this.onSelectAll.bind(this)}
                onCollapse={this.onCollapse.bind(this)}
                //  progress={progress}
                onClickItem={this.onClickItem.bind(this)}
                className="mt-3"
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(TransferHistoryPage);
